const tenant = require(`./tenants/${process.env.NEXT_PUBLIC_TENANT}.js`);

module.exports = {
  locales: tenant.locales,
  defaultLocale: 'en',
  localeDetection: false,
};
